import React, { useState } from 'react'
import { IconButton, Tooltip, Dialog } from '@material-ui/core'
import AssignmentIcon from '@material-ui/icons/Assignment'
import PlusOneIcon from '@material-ui/icons/PlusOne'
import { DetalleCamionesEnPlayaView } from '../components/DetalleCamionesEnPlayaView'

export default function DetallesCamionesEnPlaya (props) {
  const { detalle } = props

  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => { setOpen(false) }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth='sm'
      >
        <DetalleCamionesEnPlayaView detalle={detalle} handleClose={handleClose} />
      </Dialog>

      <Tooltip title={'Ver detalles'}>
        <IconButton onClick={() => handleOpen()}>
          <AssignmentIcon fontSize='default' color='primary' />
        </IconButton>
      </Tooltip>
      {(detalle.estadoCalificacion === 'R' || detalle.rechazoAdministrativoCalado === 'R') &&
        <Tooltip title={'Ésta CPE posee un RECHAZO anterior'}>
          <PlusOneIcon fontSize='default' color='secondary' />
        </Tooltip>
      }
    </>
  )
}
